import React, { FC } from 'react';
import { connect } from 'react-redux';

import type { ChangeHandler } from '../../types';
import type { ReduxState } from 'app/redux/types';

import { hasAccountRequiredName } from 'app/lib/account/selectors';
import { getBetPresets } from 'app/lib/site-configs/selectors';
import type { PresetItem } from 'app/lib/site-configs/transform-preset-item';

import { isPreset } from '../../utils/is-preset';
import Freebet, { type ExtendedFreeBet } from './Freebet';
import Preset from './Preset';

import styles from '../../FooterBar.module.scss';

type StoreProps = {
  hasRequiredName: boolean;
  presetItems: PresetItem[];
};

type BarContentProps = {
  betId?: number;
  freeBetItems: ExtendedFreeBet[];
  onChange: ChangeHandler;
};

const BarContent: FC<BarContentProps & StoreProps> = ({
  betId,
  hasRequiredName,
  presetItems,
  freeBetItems,
  onChange,
}) => {
  const barItems = hasRequiredName ? [...presetItems, ...freeBetItems] : presetItems;
  return (
    <div className={styles.barContainer}>
      {barItems.map((barItem, index) => {
        if (isPreset(barItem)) {
          return (
            <Preset key={`${betId}-${index}`}
                    betId={betId}
                    {...barItem} />
          );
        }

        return (
          <Freebet key={barItem.id}
                   betId={betId}
                   freebet={barItem}
                   onChange={onChange} />
        );
      })}
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  hasRequiredName: hasAccountRequiredName(state),
  presetItems: getBetPresets(state) || [],
});

export default connect(mapStateToProps)(BarContent);
